import { getUsersPlugin } from './utils/get-users';

import { type ReactNode } from 'react';

import BaseCrossFlowProvider from '@atlassiansox/cross-flow-support/wac';

import { useAnalyticsClient } from '../../../analytics/wac-analytics/analytics-client';

export type CrossFlowProviderProps = {
	children: ReactNode;
	cloudId?: string;
	locale?: string;
};

export const CrossFlowProvider = ({ children, cloudId, locale = 'en' }: CrossFlowProviderProps) => {
	const analyticsClient = useAnalyticsClient();
	return (
		<BaseCrossFlowProvider
			cloudId={cloudId}
			// @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
			analyticsClient={analyticsClient}
			locale={locale}
			plugins={[getUsersPlugin]}
		>
			{children}
		</BaseCrossFlowProvider>
	);
};
